/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/registerMappers";
import * as Parameters from "../models/parameters";
/** Class representing a Register. */
var Register = /** @class */function () {
  /**
   * Create a Register.
   * @param {LabsApiClientContext} client Reference to the service client.
   */
  function Register(client) {
    this.client = client;
  }
  Register.prototype.global = function (registrationCode, options, callback) {
    return this.client.sendOperationRequest({
      registrationCode: registrationCode,
      options: options
    }, globalOperationSpec, callback);
  };
  Register.prototype.regional = function (region, registrationCode, options, callback) {
    return this.client.sendOperationRequest({
      region: region,
      registrationCode: registrationCode,
      options: options
    }, regionalOperationSpec, callback);
  };
  Register.prototype.regionalWithSubscription = function (region, registrationCode, options, callback) {
    return this.client.sendOperationRequest({
      region: region,
      registrationCode: registrationCode,
      options: options
    }, regionalWithSubscriptionOperationSpec, callback);
  };
  return Register;
}();
export { Register };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var globalOperationSpec = {
  httpMethod: "PUT",
  path: "api/me/register/{registrationCode}",
  urlParameters: [Parameters.registrationCode],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {},
    201: {},
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var regionalOperationSpec = {
  httpMethod: "PUT",
  path: "{region}/api/me/register/{registrationCode}",
  urlParameters: [Parameters.region, Parameters.registrationCode],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {},
    201: {},
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var regionalWithSubscriptionOperationSpec = {
  httpMethod: "PUT",
  path: "{region}/api/subscription/{subscriptionId}/register/{registrationCode}",
  urlParameters: [Parameters.region, Parameters.subscriptionId, Parameters.registrationCode],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {},
    201: {},
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};